define('shared/initializer/etctxtsess',[
    'shared/lib/RSVP',
    'shared/lib/cookie',
    'shared/util/security/Encoding',
    'shared/util/state',
    'shared/util/state/adapters/onChange',
    'shared/util/state/adapters/session',
    'shared/util/state/adapters/user'
], function(
    RSVP,
    cookie,
    Encoding, 
    state,
    onChangeAdapter,
    sessionAdapter,
    userAdapter
){
    'use strict';

    var KEY_STATE_PARTNER_CODE = 'session.partner_code';
    var KEY_STATE_MEMBER_ID = 'user.member_id';
    var KEY_STATE_MEMBER_TYPE = 'user.member_type';
    var KEY_COOKIE = 'etctxtsess';
    var MAPPING_MEMBER_TYPE = {
        'member': 'M',
        'student': 'S',
        '': 'U'
    };
    var values = {};
    var syncingPromise;
    var inited;

    function getDomain() {
        var domain = window.location.hostname;
        return domain;
    }

    function sync(ptn, memberId, memberType, emailLanguageCode){
        if ( ptn == null ) {
            return RSVP.resolve();
        }

        if ( ptn.length < 3 ) {
            // partner code can be SME so the least length will be 3
            return RSVP.reject('Partner code format incorrect');
        }

        if (ptn === 'None') {
            ptn = '';
        }

        var memberTypeNormalized = (memberType || '').toLowerCase();

        if ( !(memberTypeNormalized in MAPPING_MEMBER_TYPE) ) {
            memberTypeNormalized = '';
        }

        memberTypeNormalized = MAPPING_MEMBER_TYPE[memberTypeNormalized];

        memberId = memberId || '-1';
        emailLanguageCode = emailLanguageCode || '';

        return Encoding.instance
            .encode(ptn + '~' + memberId + '~' + memberTypeNormalized + '~' + emailLanguageCode)
            .then(function(hashed){
                cookie.set(KEY_COOKIE,
                    'ver=1.5|' + hashed, 
                    {
                        domain: getDomain(),
                        path: '/',
                        encode: false
                    });
            });

    }

    function syncSession() {
        if( syncingPromise ) {
            return syncingPromise
                .then(function(){
                    return syncSession();
                });
        }

        syncingPromise = RSVP.resolve()
            .then(function(){
                return RSVP.all([
                    state.get(KEY_STATE_PARTNER_CODE),
                    state.get(KEY_STATE_MEMBER_ID),
                    state.get(KEY_STATE_MEMBER_TYPE)
                ]);
            })
            .then(function(){
                var args = Array.prototype.concat.apply([], arguments[0]);
                return sync.apply(this, args);
            })
            .then(function(){
                syncingPromise = null;
            });
    }

    return {
        init: function(){
            if ( inited ) {
                return inited;
            }
            
            inited = RSVP.resolve()
                .then(function(){
                    return RSVP.all([
                        state.adapters.add(onChangeAdapter),
                        state.adapters.add(sessionAdapter),
                        state.adapters.add(userAdapter)
                    ]);
                })
                .then(function(){
                    syncSession();

                    onChangeAdapter.on('change', function(key, value){
                        if ( 
                            key !== KEY_STATE_PARTNER_CODE &&
                            key !== KEY_STATE_MEMBER_ID && 
                            key !== KEY_STATE_MEMBER_TYPE 
                        ) {
                            return;
                        }

                        if ( values[key] === value ) {
                            return;
                        }

                        values[key] = value;

                        // resync session when value changed
                        syncSession();
                    });
                });
            return inited;
        }
    };
});
